import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import React, { useEffect, useState } from 'react';

const DarkModeToggle = () => {
  const [darkMode, setDarkMode] = useState(() =>
    localStorage.getItem('theme') === 'dark'
  );

  useEffect(() => {
    const root = window.document.documentElement;
    if (darkMode) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  return (
    <button type="button" title="Toggle dark mode" className="-m-2.5 p-2.5 text-gray-600 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" onClick={() => setDarkMode(!darkMode)}>
      {darkMode ? <SunIcon aria-hidden="true" className="size-6" /> : <MoonIcon aria-hidden="true" className="size-6" />}
    </button>
  );
};

export default DarkModeToggle;
